import { render, staticRenderFns } from "./foldItem.vue?vue&type=template&id=3ebacdae&scoped=true"
import script from "./foldItem.vue?vue&type=script&lang=js"
export * from "./foldItem.vue?vue&type=script&lang=js"
import style0 from "./foldItem.vue?vue&type=style&index=0&id=3ebacdae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebacdae",
  null
  
)

export default component.exports